import { SUBDOMAINS } from './enums';
import Winc from '@readcloud/clouds-and-content/src/components/winc.svg';
import ReadCloud from '@readcloud/clouds-and-content/src/components/readcloud.svg';
import Jis from '@readcloud/clouds-and-content/src/components/jis.png';
import Hillcrest from '@readcloud/clouds-and-content/src/components/hillcrest.svg';
import { Logos } from '@readcloud/clouds-and-content/src/components/logos/logos';

const domainsToLogo = {
  [SUBDOMAINS.MAIN]: ReadCloud,
  [SUBDOMAINS.LOCALHOST]: ReadCloud,
  [SUBDOMAINS.WINC]: Winc,
  [SUBDOMAINS.JIS]: Jis,
  [SUBDOMAINS.ROSEBANKSC]: 'https://assets.readcloud.com/logos/rosebank.jpg',
  [SUBDOMAINS.HILLCRESTCC]: Hillcrest,
  [SUBDOMAINS.STLAURENCE]: Logos.Stlaurence,
  [SUBDOMAINS.S_CROSS]: Logos.SCross,
  [SUBDOMAINS.BEAUDESERT]: Logos.Beaudesert,
  [SUBDOMAINS.ROCKHAMPTON]: Logos.Rockhamptons,
  [SUBDOMAINS.PGONLINE]: Logos.PGOnline,
  [SUBDOMAINS.PRSPNE]: Logos.PRSPNE,
  [SUBDOMAINS.ISFWATERLOO]: Logos.ISFWaterloo,
  [SUBDOMAINS.ALBANYSHS]: Logos.Albanyshs,
  [SUBDOMAINS.AVIATIONHIGH]: Logos.AviationHigh,
  [SUBDOMAINS.AVILACOLLEGE]: Logos.Avilacollege,
  [SUBDOMAINS.BILOELASHS]: Logos.Biloelashs,
  [SUBDOMAINS.BSSSC]: Logos.BSSSC,
  [SUBDOMAINS.BUNDABERGSHS]: Logos.BundabergSHS,
  [SUBDOMAINS.GYMPIESHS]: Logos.GympieSHS,
  [SUBDOMAINS.MALANDASHS]: Logos.MalandaSHS,
  [SUBDOMAINS.MOSSMANSHS]: Logos.Mossmanshs,
  [SUBDOMAINS.NAMBOURSC]: Logos.Namboursc,
  [SUBDOMAINS.NANANGOSHS]: Logos.NanangoSHS,
  [SUBDOMAINS.PEDARECC]: Logos.Pedarecc,
  [SUBDOMAINS.PROSERPINESHS]: Logos.ProserpineSHS,
  [SUBDOMAINS.REDBANKPLAINSSHS]: Logos.Redbankplains,
  [SUBDOMAINS.SPRINGFIELDCENTRALSHS]: Logos.SpringfieldCentral,
  [SUBDOMAINS.STJAMESCOLLEGE]: Logos.StJamesCollege,
  [SUBDOMAINS.SPCC]: Logos.Spccqld,
  [SUBDOMAINS.TANNUMSANDSSHS]: Logos.TannumsandsSHS,
  [SUBDOMAINS.TCCR]: Logos.Tccr,
  [SUBDOMAINS.VPSHS]: Logos.Vpshs,
  [SUBDOMAINS.WSSC]: Logos.Wssc,
  [SUBDOMAINS.WMYC]: Logos.Wmyc,
  [SUBDOMAINS.WOODCRESTSC]: Logos.Woodcrestsc,
  [SUBDOMAINS.YERONGASHS]: Logos.Yerongashs,
  [SUBDOMAINS.SUNCOASTCC]: Logos.Suncoastcc,
  [SUBDOMAINS.CHANCELLORSC]: Logos.Chancellorsc,
  [SUBDOMAINS.INDOOROOSHS]: Logos.Indoorooshs,
  [SUBDOMAINS.STMARYSCOLLEGE]: Logos.Stmaryscollege,
  [SUBDOMAINS.SAMPOERNAACADEMY]: Logos.Sampoernaacademy,
  [SUBDOMAINS.ASPLEYSHS]: Logos.Aspleyshs,
  [SUBDOMAINS.WARWICKSHSWA]: Logos.Warwickshswa,
  [SUBDOMAINS.WYNNUMSHS]: Logos.Wynnumshs,
  [SUBDOMAINS.TRINITYBAYSHS]: Logos.Trinitybayshs,
  [SUBDOMAINS.SISSCHOOLS]: Logos.Sisschools,
  [SUBDOMAINS.CHARTERHOUSEALMATY]: Logos.CharterHouse,
  [SUBDOMAINS.EMMAUS]: Logos.Emmaus,
  [SUBDOMAINS.CALLIOPE]: Logos.Calliopeshs,
  [SUBDOMAINS.ATHERTON]: Logos.Athertonshs,
  [SUBDOMAINS.PRONIN]: Logos.Pronin,
  [SUBDOMAINS.TRANSYLVANIA]: Logos.Transylvania,
  [SUBDOMAINS.VICTORYCOLLEGE]: Logos.VictoryCollege,
  [SUBDOMAINS.BMEZY]: Logos.Bmezy,
  [SUBDOMAINS.PERIDIS]: Logos.Peridis,
  [SUBDOMAINS.CALVARY]: Logos.Calvary,
  [SUBDOMAINS.SCOTSPGC]: Logos.Scotspgc,
  [SUBDOMAINS.IBID]: Logos.Ibid,
  [SUBDOMAINS.SEVENSTEPS]: Logos.SevenSteps,
  [SUBDOMAINS.DALBY]: Logos.Dalby,
} as const;

export { domainsToLogo };
